import { formatISODateTime } from "./components/helpers";
import namedRoutes from "./settings/routes";

const baseDomain = "tysonsgearlab.com";

export const getBaseUrl = () => {
  let protocol = "https:";
  let domain = process.env.SITE_DOMAIN || baseDomain;

  if (domain === "auto") {
    if (typeof window !== "undefined") {
      protocol = window.location.protocol;
      domain = window.location.host;
    } else {
      domain = baseDomain;
    }
  }

  return `${protocol}//${domain}`;
};

export const generateSchemaGraph = (data = {}) => {
  const baseUrl = getBaseUrl();
  const pageUrl = `${baseUrl}${data.url || ""}`;
  const cleanPageUrl = pageUrl.split("?")[0];

  const pageTitle = data.title || data.og_title;
  const headline = data.schema_headline || pageTitle;
  const schemaType = data.schema_type || "Article";

  // Author
  const authorNode = {
    "@type": "Person",
    "@id": `${baseUrl}/#author`,
    name: "Tyson Matanich",
    url: `${baseUrl}${namedRoutes.about}`,
    image: `${baseUrl}/images/author.webp`,
  };
  if (data.url === namedRoutes.about) {
    //authorNode.description = "Software engineer and reviewer specializing in off-grid power systems, EcoFlow products, and vanlife electrical setups.";
    authorNode.mainEntityOfPage = pageUrl;
    authorNode.sameAs = [
      "https://www.linkedin.com/in/tysonmatanich/",
      "https://github.com/tysonmatanich",
      "https://x.com/tysonmatanich",
      "https://www.smashingmagazine.com/author/tyson-matanich/",
      "https://www.matanich.com/",
      "https://reviews.matanich.com/",
      "https://www.mobygames.com/person/663701/tyson-matanich/",
    ];
    authorNode.subjectOf = [
      "https://www.igdb.com/games/halo-5-guardians/credits/",
      "https://www.halowaypoint.com/halo-infinite/credits",
      "https://www.halowaypoint.com/halo-the-master-chief-collection/credits",
      "https://responsivewebdesign.com/podcast/microsoft/",
      "https://www.smashingmagazine.com/2016/07/how-i-ended-up-with-element-queries-and-how-you-can-use-them-today/",
      "https://rainypixels.com/words/the-story-of-the-new-microsoft-com/",
      // "https://allaboutwindowsphone.com/flow/item/15858_The_design_story_behind_Micros.php",
      // "https://trentwalton.com/2012/10/03/a-new-microsoft-com/",
      // "https://daverupert.com/2013/04/responsive-deliverables/",
    ];
    //authorNode.knowsAbout = [];
  }

  // Publisher
  const publisherNode = {
    "@type": "Organization",
    "@id": `${baseUrl}/#organization`,
    name: "Tyson's Gear Lab",
    url: `${baseUrl}/`,
    logo: `${baseUrl}/icons/favicon-96x96.png`,
    // sameAs: [
    //   "https://www.youtube.com/@TysonsGearLab",
    //   "https://www.facebook.com/TysonsGearLab/",
    //   "https://www.instagram.com/tysonsgearlab/",
    // ],
  };

  // Page
  const primaryNode = {
    "@type": schemaType,
    "@id": `${cleanPageUrl}#${schemaType.toLowerCase()}`,
    url: pageUrl,
    mainEntityOfPage: pageUrl,
    name: pageTitle,
    headline: headline,
    description: data.description,
    author: { "@id": `${baseUrl}/#author` },
    publisher: { "@id": `${baseUrl}/#organization` },
    inLanguage: "en",
    //keywords: data.keywords
  };
  if (data.datePublished) {
    primaryNode.datePublished = formatISODateTime(data.datePublished);
  }
  if (data.dateModified) {
    primaryNode.dateModified = formatISODateTime(data.dateModified);
  }

  // Images
  const rawImageData = data.schema_image || data.og_image;
  if (rawImageData) {
    const formatUrl = (img) => {
      if (img.startsWith("/")) {
        return `${baseUrl}${img}`;
      } else if (img.startsWith("https://") || img.startsWith("http://")) {
        return img;
      }
      return `${baseUrl}/${img}`;
    };

    const imageList = Array.isArray(rawImageData)
      ? rawImageData.map(formatUrl)
      : [formatUrl(rawImageData)];

    // Assign direct URL strings to the primary node
    primaryNode.image = imageList.length === 1 ? imageList[0] : imageList;
    primaryNode.thumbnailUrl = imageList[0];
  }

  // YouTube
  const yt = data.youtube;
  let videoNode = null;
  if (yt && yt.id) {
    primaryNode.video = { "@id": `${cleanPageUrl}#video` };

    videoNode = {
      "@type": "VideoObject",
      "@id": `${cleanPageUrl}#video`,
      name: yt.title || headline,
      thumbnailUrl: [`https://img.youtube.com/vi/${yt.id}/maxresdefault.jpg`],
      embedUrl: `https://www.youtube.com/embed/${yt.id}`,
      contentUrl: `https://www.youtube.com/watch?v=${yt.id}`,
    };

    if (yt.description) {
      videoNode.description = yt.description;
    }
    if (yt.datePublished) {
      videoNode.uploadDate = formatISODateTime(yt.datePublished);
    }
  }

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        url: `${baseUrl}/`,
        name: "Tyson's Gear Lab",
        mainEntityOfPage: `${baseUrl}/`,
        publisher: { "@id": `${baseUrl}/#organization` },
      },
      publisherNode,
      authorNode,
      primaryNode,
      ...(videoNode ? [videoNode] : []),
    ],
  };
};
